import React from "react";
import Title from "./Elements/Title";


//IMAGES

import TitleBG from "../images/background-01.jpg";
import TitleBGRet from "../images/background-01@2x.jpg";
import TitleBGWebp from "../images/background-01.webp";
import TitleBGWebpRet from "../images/background-01@2x.webp";

import src01 from "../images/image1_1-01.jpg";
import src01Ret from "../images/image1_1-01@2x.jpg";
import webp01 from "../images/image1_1-01.webp";
import webp01Ret from "../images/image1_1-01@2x.webp";

import src02 from "../images/image1_2-01.jpg";
import src02Ret from "../images/image1_2-01@2x.jpg";
import webp02 from "../images/image1_2-01.webp";
import webp02Ret from "../images/image1_2-01@2x.webp";

import src03 from "../images/image1_2-02.jpg";
import src03Ret from "../images/image1_2-02@2x.jpg";
import webp03 from "../images/image1_2-02.webp";
import webp03Ret from "../images/image1_2-02@2x.webp";

import src04 from "../images/image1_3-01.jpg";
import src04Ret from "../images/image1_3-01@2x.jpg";
import webp04 from "../images/image1_3-01.webp";
import webp04Ret from "../images/image1_3-01@2x.webp";

import srcArticle from "../images/article-01.jpg";
import srcArticleRet from "../images/article-01@2x.jpg";
import webpArticle from "../images/article-01@2x.jpg";
import webpArticleRet from "../images/article-01@2x.webp";

import Content from "./Elements/Content";
import Block from "./Elements/Block";
import Image from "./Global/Image";

import styles from "./Section01.module.scss";
import Quote from "./Elements/Quote";
import ImageText from "./Elements/ImageText";
import Highlight from "./Elements/Highlight";
import TimeRemote from "./Graph/TimeRemote";
import AttractionRemote1 from "./Graph/AttractionRemote1";
import AttractionRemote2 from "./Graph/AttractionRemote2";
import ArticleLink from "./Elements/ArticleLink";

export default function Section01() {
    const sectionTitle = `Pandémie : <br/> « un booster historique » pour le télétravail`;

    return (
        <Content classname={'navigation--1'}>
            <Title title={sectionTitle} numero={1}
                   background={{src: TitleBG, srcRet: TitleBGRet, webp: TitleBGWebp, webpRet: TitleBGWebpRet}}/>

            <Block title={'Un monde du travail en mutation'} {...{sectionTitle}} number={1.1} classname={'navigation--2'}
                   container={'true'}>
                <div className="text-wrapper right">
                    <p className={'size-5'}>
                        Selon l’OCDE, après la crise sanitaire, les offres d'emploi avec télétravail devraient se stabiliser à 7,5%. Ce niveau a plus que triplé depuis la pandémie, avec des écarts sans surprise très importants selon les pays et les secteurs d’activité. L'organisation a passé au crible l'évolution de la part des offres d'emploi en distanciel sur la plateforme Indeed, en fonction du renforcement ou de l'allègement des restrictions sanitaires dans 20 pays différents. Evidemment, toutes les professions ne sont pas concernées. Les secteurs numériques et les professions très qualifiées se sont rapidement converties à cette nouvelle organisation et sa part peut atteindre jusqu'à 11% pour les fonctions informatique ou marketing. Le recours à la pratique n'atteint pas 1% pour les fonctions productives. A noter qu’en France, selon l'Association nationale des DRH (ANDRH), 60% des gens exercent des professions qui ne sont pas télétravaillables.
                    </p>
                </div>

                <Image classname={[styles.Image, 'size-8'].join(' ')}
                       src={src01} srcRet={src01Ret} webp={webp01} webpRet={webp01Ret}
                       radius={true}/>

                <div className="text-wrapper right">
                    <p className={'size-5'}>
                        L’étude de l’OCDE montre qu’en Italie, pays où le numérique est peu développé, la part des offres d'emploi en télétravail a bondi à plus de 9% de janvier 2020 à avril 2021, avant de retomber à 5% au cours des cinq mois suivants, les restrictions s’étant progressivement assouplies. En revanche, aux Etats-Unis, où la pénétration du numérique est élevée, la part des offres d'emploi a augmenté pour atteindre 7% de janvier 2020 à janvier 2021, avant de se stabiliser, indiquant une évolution plus persistante de l'organisation du travail. Le même phénomène a été observé dans le nord de l'Europe comme aux Pays-Bas, au Luxembourg ou encore en Finlande, des pays où un actif sur trois télétravaille. Le Japon fait figure d’exception dans le monde. Tokyo a imposé très peu de restrictions et le télétravail ne s’est jamais imposé. Actuellement, moins de 1% des offres d'emploi proposent le travail à distance.
                    </p>
                </div>

                <Highlight classname={styles.Table}
                           title={`Estimation du temps de travail télétravaillable selon les pays `}
                           source={`McKinsey Global Institute, «What’s next for remote work», un modèle basé sur plus de 2.000 activités, 800 professions et neuf pays, novembre 2020.`}
                           color={'yellow'}>
                    <div className={styles.GraphWrapper}>
                        <TimeRemote/>
                    </div>
                </Highlight>
            </Block>

            <Block title={'Un désir de télétravail'} sectionTitle={sectionTitle} number={1.2} classname={'navigation--2  pb-0'}>
                <div className="container">
                    <ImageText image={{src: src02, srcRet: src02Ret, webp: webp02, webpRet: webp02Ret}} radius={true} classname={'large rtl'} align={'flex-end'}>
                        <p>
                            Les entreprises semblent d’ailleurs avoir intégré ce changement de paradigme : 74% d’entre elles ont déclaré qu’elles allaient assigner à certains employés des postes de télétravail permanents, selon une étude du cabinet Gartner. Aux Etats-Unis, Twitter, Square et Nielsen faisaient déjà partie des entreprises qui proposait d’adopter une pratique du télétravail régulière. American Express, Reuters et Airbnb ont également étendu leurs politiques sur le travail à domicile depuis la crise sanitaire, tout comme Google.
                        </p>
                    </ImageText>
                </div>

                <div className="outside--wrapper">
                    <ImageText image={{src: src03, srcRet: src03Ret, webp: webp03, webpRet: webp03Ret}} radius={true} classname={'layer image-out mb-0'}>
                        <p>
                            Cet engouement pour le télétravail est également exprimé par les travailleurs. Début janvier, l'Ifop a publié une étude menée pour la Fondation Jean Jaurès en Allemagne, Espagne, France, Italie et au Royaume-Uni. Interrogés sur le nombre de jours souhaité dans l'idéal en télétravail, une proportion importante des interviewés des cinq pays voudrait le pratiquer au moins une journée par semaine : 80% en Espagne (+44 points par rapport à la pratique réelle), 74% en Italie (+24 points), 62% au Royaume-Uni (+20 points), 69% en Allemagne (+18 points) et 69% également en France (+40 points). La fréquence moyenne idéale de télétravail souhaitée oscille ainsi entre 1,8 jour par semaine en France, et 2,7 en Espagne. Au milieu, elle est de 2 jours par semaine au Royaume-Uni, 2,2 jours en Allemagne et 2,4 jours en Italie.
                        </p>
                    </ImageText>
                </div>

                <Highlight title={`L’attrait du télétravail en Europe `}
                           source={`Données sur le télétravail dans cinq pays d'Europe, villes et régions, selon une étude de Morgan Stanley publiée le 4 août 2020 / AFP - Alain BOMMENEL`}
                           color={'beige'} classname={[styles.Attraction, 'full'].join(' ')}>

                    <div className={styles.AttractionWrapper}>
                        <AttractionRemote1/>
                        <AttractionRemote2/>
                    </div>
                </Highlight>
            </Block>

            <Block title={'Des avantages pour les entreprises '} number={1.3} sectionTitle={sectionTitle} classname={['navigation--2'].join(' ')}>
                <div className="container">
                    <p className={'size-5 ml-4'}>
                        Les avantages sont nombreux pour les employeurs, avec notamment des coûts réduits : des économies peuvent être réalisées sur les loyers des bureaux et les dépenses connexes, comme les factures d’électricité et les impôts fonciers. Le temps de présence des équipes est optimisé, puisque le travail à distance ne nécessite pas de trajet quotidien, ce qui permet d’optimiser chaque heure de la journée.  La suppression des obstacles géographiques est également un avantage : si le meilleur candidat pour un poste vit à quatre heures de route, cela pourrait ne plus être rédhibitoire.
                    </p>


                    <Image classname={[styles.Image, 'size-7 ml-1'].join(' ')}
                           src={src04} srcRet={src04Ret} webp={webp04} webpRet={webp04Ret}
                           radius={true}/>

                    <p className={'size-5 ml-4'}>
                        Néanmoins, certains patrons ont eu du mal à prendre le pli du télétravail, redoutant que leurs équipes échappent en partie à leur contrôle, en n’étant plus sous leurs yeux au bureau. En France, l'institut Sapiens, un think tank libéral a publié en 2021 une étude qui montre que travailler depuis son domicile a entraîné la réduction du nombre de distractions et de perturbations (pauses café, pauses cigarettes, long déjeuner, bruit...) tout en augmentant la motivation par la responsabilisation. Conclusion : les employés ne se tournent pas les pouces, avec une productivité évaluée en hausse de 22%. Autre vertu du télétravail : réduire considérablement l'absentéisme, dont le coût est habituellement estimé à 108 milliards par an en France.
                    </p>

                    <Quote sourceText={`affirment les experts de <strong>l’Institut Sapiens</strong>`}>
                        Le télétravail est un outil permettant de résoudre
                        les nombreux dysfonctionnements managériaux, qui, en plus de miner la qualité de vie au travail, provoquent également l'absentéisme en sein des entreprises
                    </Quote>

                    <p className={'size-5 ml-4'}>
                        Un bémol, toutefois : pour être bénéfique sur le long terme, le dispositif doit être bien encadré, les salariés absents des entreprises se retrouvant en manque de lien et de sociabilisation. "Imposé sur du long terme sans négociation avec les salariés ni suivis suffisants, le télétravail pourrait à l'inverse engendrer jusqu'à 20% de pertes de productivité s'il est mal géré par les entreprises", nuance Laurent Cappelletti, professeur au Conservatoire national des arts et métiers (Cnam) et coauteur de l'étude.
                    </p>
                </div>
                <ArticleLink title={`Télétravail : l'aventure ne fait que commencer !`} href={'https://www.boursier.com/dossiers/travail-a-distance-avec-etoro/economie/teletravail-l-aventure-ne-fait-que-commencer-47785.html'} image={{src: srcArticle, srcRet: srcArticleRet, webp: webpArticle, webpRet: webpArticleRet}}/>

            </Block>
        </Content>
    )
}
